import API from './API';

const path = `tratamentos`;

const TratamentoService = {
    
    documentos: async () => await API.list(`${path}/sintetico`),

}

export default TratamentoService;